import { useMemo, useState } from 'react';
import _ from 'lodash';
import { Box } from '@material-ui/core';
import { AutoCompleteSelect } from '../../../../../components';
import Dialog from '../../../../../components/Dialog';

const LinkedBedPopup = ({ allData, handleClose, handleSubmit }) => {
  const [selectedBed, setSelectedBed] = useState('');

  const itemList = useMemo(() => {
    return [
      { text: `${allData.ccWardCd} ${allData.bedNo}`, value: String(allData.bedStatusId) },
      ..._.map(allData.linkeds, (item) => ({
        text: `${item.ccWardCd} ${item.bedNo}`,
        value: String(item.bedStatusId),
      })),
    ];
  }, [allData]);

  const disabled = useMemo(() => !selectedBed, [selectedBed]);

  return (
    <Dialog
      open={true}
      title="Save Remark"
      confirm="Save"
      cancel="Cancel"
      handleCancel={handleClose}
      handleClose={handleClose}
      handleConfirm={() => handleSubmit({ bedStatusId: selectedBed })}
      disabled={disabled}
    >
      Kindly select the assigned bed no and ward code for the transfer in request
      <Box mt="1rem">
        <AutoCompleteSelect itemList={itemList} value={selectedBed} onChange={setSelectedBed} />
      </Box>
    </Dialog>
  );
};

export default LinkedBedPopup;
